import $ from 'jquery';
window.$ = window.jQuery = $;

import {
	menuFixed,
	menuMobile,
	headerSearch
} from "./js/menu";
import {
	homeFeaturedArticlesScroll,
	teamCols,
	backToTop,
} from "./js/ui";
import {
	homeHeroBanner,
	homeFeaturedArticles,
	homeMostReadArticles,
	homeReports,
	sectionHeroBanner
} from "./js/slider";

(($) => {
    $(() => {
		// menuFixed()
		menuMobile()
		backToTop()
		headerSearch()

		// homeFeaturedArticlesScroll()
		homeMostReadArticles()
		homeHeroBanner()
		homeFeaturedArticles()
		homeReports()

		sectionHeroBanner()
		teamCols()
	})
})(jQuery)